module.exports = __webpack_public_path__ + "static/media/blackcomplete.a015e713.svg";